import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-25 md:flex md:flex-row md:justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-20" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WishListsAddList = _resolveComponent("WishListsAddList")!
  const _component_WishListsThumbView = _resolveComponent("WishListsThumbView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.labels.listHeading), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WishListsAddList, { class: "w-full md:w-2/5" })
    ]),
    _hoisted_2,
    _createVNode(_component_WishListsThumbView, {
      model: _ctx.wishLists,
      "details-url": _ctx.detailsUrl
    }, null, 8, ["model", "details-url"])
  ]))
}